module.exports = __webpack_public_path__ + "static/media/WSB_favicon.3b4b77e7.ico";